import { XyoWorldBidder, XyoWorldGeotokenWrapper } from '@xyo-network/sdk-xyoworld-js'
import BigNumber from 'bn.js'
import { createContext } from 'react'

interface BidderContextProps {
  bidder?: XyoWorldBidder
  currentAllowance?: BigNumber
  currentBalance?: BigNumber
  geoTokensBidOn?: number
  geotokensOwned?: XyoWorldGeotokenWrapper[]
  maxXyo?: BigNumber
  pendingCount?: number
  totalBids?: number
  xyoInGeotokens?: BigNumber
}

export const BidderContext = createContext<BidderContextProps>({})
